<template>
    <div id="login" class="general-container">
        <div class="wrap-footer">
            <div id="footer">
                <div class="inner-footer">
                    <div class="foot">
                        <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备15026634号-5</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="general-container--bg"></div>
        <div class="main-container">
            <div class="header">
                <div class="header--logo"></div>
                <div class="header--text">{{areaName}}德育在线平台</div>
            </div>
        </div>
        <div class="login-container">
            <div class="login-tab-container">
                <span @click="loginType = 0" :class="['login-tab', loginType === 0 ? 'login-tab--active' : '']">
                    <span class="login-tab--inner">扫码登录</span>
                </span><span @click="loginType = 1"
                :class="['login-tab', loginType === 1 ? 'login-tab--active' : '']">
                <span class="login-tab--inner">账号登录</span>
            </span>
            </div>
            <div class="login-code-container" v-show="loginType === 0">
                <div class="login-code-cornor login-code-cornor--1"></div>
                <div class="login-code-cornor login-code-cornor--2"></div>
                <div class="login-code-cornor login-code-cornor--3"></div>
                <div class="login-code-cornor login-code-cornor--4"></div>
                <div id="login-code"></div>
            </div>
            <div class="login-accounting-container" v-show="loginType === 1">
                <el-form autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm"
                         label-position="left" label-width="0px" class="card-box login-form">
                    <el-form-item prop="account" class="white-back">
                            <span class="svg-container">
                                <i class="icon iconfont icon-identification"></i>
                            </span>
                        <el-input name="account" type="text" v-model="loginForm.account" auto-complete="off"
                                  placeholder="手机号码"></el-input>
                    </el-form-item>
                    <input type="password" style="display: none;"/>
                    <el-form-item prop="password" class="white-back">
                            <span class="svg-container">
                                <i class="icon iconfont icon-password"></i>
                            </span>
                        <el-input name="password" type="password" v-model="loginForm.password" auto-complete="off"
                                  placeholder="密码" @keyup.enter.native="handleLogin"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" style="width:100%;" :loading="loading"
                                   @click.native.prevent="handleLogin">
                            登录
                        </el-button>
                    </el-form-item>

                </el-form>
            </div>
        </div>
        <el-dialog title="您是第一次使用微信登录，请验证您的微信账号" size="tiny" :visible.sync="dialogBindWxVisible"
                   :close-on-press-escape='false' :close-on-click-modal='false' :modal-append-to-body='false'
                   @close="dialogChoseSchoolClose">
            <div class="change-passbox">
                <el-form :model="wxLoginForm" status-icon :rules="wxLoginFormRule" ref="wxLoginFormRuleForm"
                         label-width="100px" class="demo-ruleForm">

                    <el-form-item label="手机号码" prop="mobile">
                        <el-input type="text" v-model="wxLoginForm.mobile" auto-complete="off" placeholder="当前您的手机号码">
                            <el-button type="danger" slot="append" :disabled="codeFlag" @click="getCode">
                                {{codeBtnTxt}}
                            </el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="code">
                        <el-input type="text" v-model="wxLoginForm.code" auto-complete="off"
                                  placeholder="您手机上收到的验证码"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogBindWxVisible = false">取 消</el-button>
                <el-button type="primary" @click="bindWx">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="首次登录需修改密码" :visible.sync="dialogResetPwdVisible" :close-on-press-escape='false'
                   :close-on-click-modal='false' :modal-append-to-body='false' @close="dialogResetPwdClose">
            <div class="change-passbox">
                <el-form :model="rulePwdForm" status-icon :rules="pwdRules" ref="ruleForm" label-width="100px"
                         class="demo-ruleForm">
                    <el-form-item label="当前密码" prop="currentPwd">
                        <el-input type="password" v-model="rulePwdForm.currentPwd" auto-complete="off"
                                  placeholder="当前密码"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码">
                        <password-input ref="passwordInput" :oldPassword="rulePwdForm.currentPwd" v-model="rulePwdForm.pass"></password-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checkPass">
                        <el-input type="password" v-model="rulePwdForm.checkPass" auto-complete="off"
                                  placeholder="确认密码"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogResetPwdVisible = false">取 消</el-button>
                <el-button type="primary" @click="resetPass">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="选择学校" :visible.sync="dialogChoseSchoolVisible" :close-on-press-escape='false'
                   :close-on-click-modal='false' :modal-append-to-body='false' @close="dialogChoseSchoolClose">
            <div class="school-box el-table__body-wrapper" :class="{ 'school-box-center': schoolList.length<5}">
                <div class="school-item" :class="{ 'school-chosed': item.checked}" :key="item.id"
                     v-for="item in schoolList" @click="chosedSchool(item)">
                    <div class="school-logo" :style="{backgroundImage:'url('+item.squareLogoUrl+')'}"></div>
                    <div class="school-name">{{item.name}}</div>
                </div>
                <div class="clear"></div>
            </div>
            <div slot="footer" class="dialog-footer">
                <div style="float:left;">
                    <el-input v-if="schoolSourceList.length>10" placeholder="学校名称" v-model="filterText"
                              icon="search"></el-input>
                </div>
                <el-button @click="dialogChoseSchoolVisible = false">取 消</el-button>
                <el-button type="primary" :loading="choseSchoolloading" @click="loginForChosedSchoold">进 入</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import baseMixin from '@/mixins/baseMixin.js'

    import {
        loginWx,
        wxBind,
        getWXInitData,
        loginForWX,
        login,
        stuLogin,
        loginForChosedSchoold,
        modifyPassword,
        getCode
    } from '@/api/Login/login';

    import {encrypt} from '@/utils/utils';
    import PasswordInput from '@/components/PasswordInput/PasswordInput';


    export default {
        name: "Login",
        components: {PasswordInput},
        mixins: [baseMixin],
        data() {
            const validateAccount = (rule, value, callback) => {
                if (value.length === 0) {
                    callback(new Error('请输入手机号码！'));
                } else {
                    callback();
                }
            };
            const validatePass = (rule, value, callback) => {
                if (value.length === 0) {
                    callback(new Error('密码不能为空！'));
                } else {
                    callback();
                }
            };
            const validateNewPass = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入密码！'));
                }
                if (value == this.rulePwdForm.currentPwd) {
                    callback(new Error('新旧密码不能相同！'));
                }
                let g = /^(?![\d]+$)(?![a-zA-Z]+$)(?![!@#$%]+$)[\da-zA-Z!@#$%]{6,20}$/;
                if (!g.test(value)) {
                    callback(new Error('密码的格式不正确！'));
                } else {
                    callback();
                }
            };
            const validateNewPass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码！'));
                } else if (value !== this.rulePwdForm.pass) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            const validateNowPass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码！'));
                }
                if (value != this.loginForm.password) {
                    callback(new Error('当前密码不正确！'));
                } else {
                    callback();
                }
            };
            const checkMobile = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机不能为空！'));
                }
                const g = /^0?1[345789][0-9]\d{8}$/;
                if (!g.test(value)) {
                    callback(new Error('手机号码格式不正确！'));
                } else {
                    callback();
                }
            };
            const checkCode = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('验证码不能为空！'));
                } else {
                    callback();
                }
            };

            return {
                areaName: '',

                loginType: 0, // 0wx  1account
                loading: false,//登录按钮加载
                choseSchoolloading: false,//选择学校加载
                showDialog: false,
                dialogChoseSchoolVisible: false,//控制显示选择学校的弹出层
                schoolList: [],//筛选后的数据，用于绑定
                schoolSourceList: [],//学校集合源数据，保留检索的所有学校
                dialogResetPwdVisible: false,//控制显示设置首次密码的弹出层
                dialogBindWxVisible: false,
                wxcode: '',//微信登录的code
                loginRules: {
                    account: [
                        {required: true, message: '手机号码不能为空！', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '密码不能为空！', trigger: 'blur'}
                    ]
                },
                rulePwdForm: {
                    currentPwd: '',
                    pass: '',
                    checkPass: ''
                },
                pwdRules: {
                    currentPwd: [
                        {validator: validateNowPass, trigger: 'blur'}
                    ],
                    checkPass: [
                        {validator: validateNewPass2, trigger: 'blur'}
                    ]
                },
                filterText: '',
                loginForm: {
                    account: '',
                    password: ''
                },
                wxLoginForm: {
                    mobile: '',
                    code: ''
                },
                wxLoginFormRule: {
                    mobile: [
                        {validator: checkMobile, trigger: 'blur'}
                    ],
                    code: [
                        {validator: checkCode, trigger: 'blur'}
                    ]
                },
                timeMax: 60,//获取验证码计时
                codeFlag: false,
                codeBtnTxt: '获取验证码',
                wxToken: '',//微信token
                timer: null//计时器
            }
        },
        created() {
            this.wxcode = this.$route.query.code;
            if (this.wxcode) {//如果是微信登录
                loginForWX(this.wxcode, 'WXLOGINNEWDYZX').then(res => {
                    let data = res.data;
                    if (data.code === 1060) {//是不是首次绑定微信帐号
                        this.dialogBindWxVisible = true;
                        this.wxToken = data.data.loginWxToken == null ? '' : data.data.loginWxToken;
                    } else {
                        this.loginPackge(data);
                    }
                }).catch();
            }
        },
        mounted() {

            let areaName = '';
            switch(window.location.host) {
                case 'xwdyzx.weixiaojia.cn':
                    areaName = '玄武';
                    break;
                case 'zy.lhedu.com.cn':
                    areaName = '六合';
                    break;
                default:
                    areaName = '玄武';
                    break;
            }
            this.areaName = areaName;

            getWXInitData().then(res => {
                let data = res.data.data;
                new WxLogin({
                    id: "login-code",
                    appid: data.appid,
                    scope: "snsapi_login",
                    redirect_uri: data.redirect_url,
                    state: "WXLOGINNEWDYZX",
                    style: "black",
                    href: "https://cdnfile-10043692.file.myqcloud.com/vuewxcep/common_css/new_wx_login.css"
                });
                // new WxLogin({
                //     id: "login-code",
                //     appid: data.appid,
                //     scope: "snsapi_login",
                //     redirect_uri: "http%3a%2f%www.weixiaojia.cn%2fwxcepClient%2fwxapp%2fwxAuth%3f",
                //     state: "WXLOGINNEW",
                //     style: "black",
                //     href: "https://cdnfile-10043692.file.myqcloud.com/vuewxcep/common_css/new_wx_login.css"
                // });
            }).catch();
        },
        methods: {
            loginForChosedSchoold() {//多学校的登录方式
                this.choseSchoolloading = true;
                let choedSchool = this.schoolList.filter(item => item.checked);
                if (choedSchool.length > 0) {
                    if (this.wxToken == '') {//如果是帐号登录
                        loginForChosedSchoold(this.loginForm.account, encrypt(this.loginForm.password), choedSchool[0].id).then(res => {
                            let data = res.data;
                            if (data.code === 1052) {//如果是首次密码登录
                                //重置密码
                                this.dialogResetPwdVisible = true;
                                this.userId = data.data.loginUserId;
                            }
                            if (data.code === 200) {//如果是登录成功
                                this.loginSuccess(data.data);
                            }

                        }).catch();
                    } else {//如果是微信扫码
                        loginWx(choedSchool[0].id, this.wxToken).then(res => {
                            let data = res.data;
                            if (data.code === 200) {
                                this.loginSuccess(data.data);
                            } else {
                                this.$message({
                                    message: data.msg,
                                    type: 'error'
                                });
                            }
                        }).catch();
                    }

                }
            },
            packageShoolList(data) {//处理返回的多学校数据，主要添加checked属性，用于标记是否被选中
                let schoolArray = [];
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        schoolArray.push({
                            id: data[i].id,
                            name: data[i].name,
                            squareLogoUrl: data[i].squareLogoUrl,
                            checked: i === 0
                        });
                    }
                }
                return schoolArray;
            },
            chosedSchool(checkedData) {
                let chosedAfterArray = [];
                this.schoolList.forEach(function (item) {
                    chosedAfterArray.push({
                        id: item.id,
                        name: item.name,
                        squareLogoUrl: item.squareLogoUrl,
                        checked: checkedData.id === item.id
                    });
                });
                this.schoolList = chosedAfterArray;
            },
            handleLogin() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.wxToken = '';//将wxtoken置为空，防止触发微信扫码逻辑
                        if(this.loginForm.account.indexOf('@') !== -1) {
                            console.log(this.loginForm.account);
                            stuLogin({
                                account: this.loginForm.account,
                                password: encrypt(this.loginForm.password)
                            }).then(res => {
                                let data = res.data;
                                this.loginPackge(data);
                            }).catch(() => {
                                this.loading = false;
                            });
                        } else {
                            login(this.loginForm.account, encrypt(this.loginForm.password)).then(res => {
                                let data = res.data;
                                this.loginPackge(data);
                            }).catch(() => {
                                this.loading = false;
                            });
                        }


                    } else {
                        return false;
                    }
                });
            },
            loginPackge(data) {//登录处理，
                if (data.code === 1055) {//如果存在多学校
                    //选择学校
                    this.wxToken = data.data.loginWxToken == null ? '' : data.data.loginWxToken;
                    this.schoolSourceList = this.packageShoolList(data.data.loginSchoolIds);
                    this.schoolList = this.schoolSourceList;
                    this.dialogChoseSchoolVisible = true;

                } else {//如果是一个学校
                    if (data.code === 1052) {//如果是首次密码登录
                        //重置密码
                        this.dialogResetPwdVisible = true;
                    }
                    if (data.code === 200) {//如果是登录成功
                        this.loginSuccess(data.data);
                    }
                }
                this.userId = data.data.loginUserId;
            },
            loginSuccess(data) {
                this.$store.dispatch('SetLoginInfo', data).then(() => {
                    this.loading = false;
                    this.$router.push('/main');
                }).catch(() => {
                    this.loading = false;
                });
            },
            dialogChoseSchoolClose() {
                this.loading = false;
            },
            dialogResetPwdClose() {
                this.loading = false;
                this.choseSchoolloading = false;
            },
            bindWx() {//绑定微信
                this.$refs.wxLoginFormRuleForm.validate(valid => {
                    if (valid) {
                        wxBind(this.wxLoginForm.code.trim(), this.wxLoginForm.mobile.trim(), this.wxToken).then(res => {
                            let data = res.data;

                            if (data.code === 200 || data.code === 1055) {
                                this.loginPackge(data);
                            } else {
                                this.$message({
                                    message: data.msg,
                                    type: 'error'
                                });
                            }
                        }).catch();
                    }
                });
            },
            getCode() {
                this.$refs.wxLoginFormRuleForm.validateField('mobile', valid => {
                    if (valid == '') {
                        this.codeFlag = true;
                        this.setTimeBtn();
                        getCode(this.wxLoginForm.mobile.trim()).then(res => {
                            let data = res.data;
                            if (data.code === 200) {
                                this.$message({
                                    message: '验证码已发送成功，请在微信上查看！',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    message: data.msg,
                                    type: 'error'
                                });
                            }
                        }).catch();
                    }
                });
            },
            setTimeBtn() {
                let _this = this;
                this.timer = setInterval(function () {
                    _this.timeMax--;
                    if (_this.timeMax == 0) {
                        _this.codeFlag = false;
                        _this.timeMax = 60;
                        _this.codeBtnTxt = '获取验证码';
                        window.clearInterval(_this.timer)
                    } else {
                        _this.codeBtnTxt = '重新获取(' + _this.timeMax + ')';
                    }
                }, 1000);
            },
            resetPass() {
                const isPassValid = this.$refs['passwordInput'].validate();
                this.$refs.ruleForm.validate(valid => {
                    if (valid && isPassValid) {
                        modifyPassword(encrypt(this.rulePwdForm.pass), encrypt(this.rulePwdForm.currentPwd), this.userId).then(res => {
                            let data = res.data;
                            if (data.code === 200) {
                                this.$message({
                                    message: '修改成功,请重新登录！',
                                    type: 'success',
                                    duration: 3000,
                                    onClose: function () {
                                        location.reload();
                                    }
                                });

                            } else {
                                this.$message({
                                    message: data.msg,
                                    type: 'error'
                                });
                            }
                        }).catch(err => {
                        });
                    }
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/mixin";
    @include reset-global;

    .general-container {
        width: 100%;
        height: 100%;
        .general-container--bg {
            @include fullByPostion;
            background: no-repeat url(../../assets/images/Login/resource-platform-bg.jpg) center center / 100% 100%;
        }
    }
    .main-container {
        padding: 80px 96px;
        position: relative;
        z-index: 2000;
    }
    .header {
        color: #314158;
        font-size: 48px;
        & > * {
            @include middleIB;
        }
        .header--logo {
            @include wh(98px, 108px);
            @include cover-bg;
            margin-right: 24px;
            background-image: url(../../assets/images/Login/resource-platform-logo.png);
        }
    }
    .login-container {
        position: absolute;
        @include wh(487px, 543px);
        right: 150px;
        top: 50%;
        transform: translateY(-50%);
        background-color: #FFFFFF;
        color: #304E72;
        box-sizing: border-box;
        padding: 50px 34px;
        box-shadow: #666 4px 4px 10px;
        border-radius: 10px;
        z-index: 2001;
    }
    .login-tab {
        @include middleIB;
        font-size: 22px;
        text-align: center;
        width: 50%;
        .login-tab--inner {
            cursor: pointer;
            display: inline-block;
            border-bottom: 2px solid transparent;
            padding-bottom: 20px;
        }
        &--active {
            .login-tab--inner {
                border-color: #304E72;
            }
        }
    }
    .login-code-container {
        position: relative;
        .login-code-cornor {
            position: absolute;
            @include wh(30px, 30px);
        }
        .login-code-cornor--1 {
            border-top: 2px solid #304E72;
            border-left: 2px solid #304E72;
            left: 50px;
        }
        .login-code-cornor--2 {
            border-top: 2px solid #304E72;
            border-right: 2px solid #304E72;
            left: 344px;
        }
        .login-code-cornor--3{
            border-bottom: 2px solid #304E72;
            border-left: 2px solid #304E72;
            left: 50px;
            top: 294px;
        }
        .login-code-cornor--4 {
            border-bottom: 2px solid #304E72;
            border-right: 2px solid #304E72;
            left: 344px;
            top: 294px;
        }
    }
    .login-accounting-container {
        margin-top: 40px;
    }

    .school-item {
        width: 140px;
        height: 140px;
        float: left;
        text-align: center;
        cursor: pointer;
        margin-left: 10px;
        margin-bottom: 10px;
        border-radius: 4px;
        border: 2px solid #fff;
        &.school-chosed {
            border: 2px solid #20a0ff;
        }
    }
    .school-logo {
        width: 100px;
        height: 100px;
        margin: 4px auto;
        background-position: center center;
        background-size: cover;
    }


    #login-code {
        overflow: hidden;
        margin-left: 64px;
        margin-top: 40px;
    }
    .wrap-footer {
        color: #000;
        position: absolute;
        text-align: center;
        width: 100%;
        bottom: 10%;
        z-index: 5000;
        a {
            color: #000;
            text-decoration: none;
        }
    }
</style>
<style lang="scss">
    #login {

        .svg-container {
            position: absolute;
            z-index: 2000;
            right: 14px;
            height: 60px;
            line-height: 58px;
            opacity: 0.7;
            i {
                font-size: 30px;
            }
        }
        .login-accounting-container {
            .el-input__inner {
                height: 60px;
                line-height: 60px;

            }
            .el-button {
                height: 60px;
                font-size: 24px;
                background-color: #304E72;
            }
            .el-form-item {
                margin-bottom: 40px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/Login/Login.vue